import { createTheme } from '@mui/material';
import { Drawer } from '@mui/material';
import styled from '@emotion/styled';

const theme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#FFFFFF',
    },
    primary: {
      main: '#ff3d03',
      light: '#009A7D'
    },
    secondary: {
      main: '#345E74',
    },
    highlight: {
      main: '#ff3d03'
    },
    lightGreen: {
      main: '#00b2b2'
    },
    purple: {
      main: '#9D4BD2'
    },
    gray: {
      main: '#6C7373'
    },
    darkerLightGreen: {
      main: '#006666'
    },
    text: {
      primary: '#666666',
    },
    success: {
      main: '#00C875',
      contrastText: '#fff',
    },
    info: {
      main: '#61ACE6',
      contrastText: '#fff',
    },
    warning: {
      main: '#FDAB3D',
      contrastText: '#fff',
    },
    error: {
      main: '#E2445C',
      contrastText: '#fff',
    }
  },

  typography: {
    fontFamily: "'Open Sans', sans-serif",
    fontDisplay: 'block'
  },
  drawer: {
    width: 248
  },
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        asterisk: { color: '#FF0000' }
      }
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: '#ff3d03',
          '&:hover': {
            backgroundColor: '#b1150a',
          },
        },
        outlined: {
          borderColor: '#ff3d03',
          color: '#ff3d03',
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: '#FF0000' },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          position: 'relative',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          '&.Mui-disabled': {
            backgroundColor: '#e4e4e4',
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
            outline: 'none',
            boxShadow: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
            boxShadow: 'none',
          },
        },
      },
    },
  },
});
export default theme;

//DRAWER MENU STYLE
export const SIDEBAR_WIDTH = 248;
export const SIDEBAR_COLLAPSED_WIDTH = 64;
export const TOPO_LOGO_HEIGHT = 128;
export const FOOTER_LOGO_HEIGHT = 62;

// Estilos compartilhados dos itens do menu — aplicáveis a qualquer "superfície"
// (drawer permanente, barra colapsada e overlay da etapa 3).
export const sidebarItemStyles = {
  '& .MuiListItemButton-root': {
    color: '#3E3E3E',
    minHeight: 32,
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '10.667px',
    paddingRight: '10.667px',
    '&:hover': {
      backgroundColor: '#FF6C03',
      color: '#FFFFFF',
      '& .MuiListItemIcon-root': { color: '#FFFFFF' },
      '& .MuiSvgIcon-root': { color: '#FFFFFF' },
      '& .MuiTypography-root': { color: '#FFFFFF' },
    },
  },
  '& .MuiListItemText-primary': { fontSize: 12 },
  '& .MuiListItemIcon-root': {
    color: '#3E3E3E',
    minWidth: 0,
    marginRight: '10.667px',
  },
  '& .MuiSvgIcon-root': { fontSize: 19, color: '#3E3E3E' },
  // Estado ativo (página atual) — não responde a hover.
  '& .Mui-selected, & .Mui-selected:hover': {
    backgroundColor: '#FCEBE0',
    color: '#FF3D03',
    position: 'relative',
    '& .MuiListItemIcon-root': { color: '#FF3D03' },
    '& .MuiTypography-root': { color: '#FF3D03' },
    '& .MuiSvgIcon-root': { color: '#FF3D03' },
  },
  '& .has-children, & .top-level': {
    '& .MuiTypography-root': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 12,
    },
  },
  '& .MuiCollapse-root': { backgroundColor: '#F2F2F2' },
  '& .MuiListItemText-inset': { paddingLeft: '29px' },
};

// Scrollbar fina estilizada (etapa 1 / overlay / barra colapsada).
export const sidebarScrollbar = {
  scrollbarWidth: 'thin',
  scrollbarColor: '#8F8F8F #FAFAFA',
  '&::-webkit-scrollbar': { width: 6 },
  '&::-webkit-scrollbar-thumb': { backgroundColor: '#8F8F8F', borderRadius: 3 },
  '&::-webkit-scrollbar-track': { backgroundColor: '#FAFAFA' },
};

export const CustomDrawer = styled(Drawer)(() => ({
  '& .MuiDrawer-paper': {
    backgroundColor: '#FAFAFA',
    color: '#3E3E3E',
    boxSizing: 'border-box',
    width: SIDEBAR_WIDTH,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRight: '1px solid #ececec',
    ...sidebarItemStyles,
  },
}));
